import { IS_PRO } from '../constants';
import { useCustomer } from './useCustomer';

export const useShowPreOrderVariants = () => {
  const { customer } = useCustomer();
  return !!customer && IS_PRO;
};
